<!--
 * @Descripttion: 
 * @Author: juanjuanhui
 * @Date: 2022-03-25 18:43:16
 * @LastEditors: juanjuanhui
 * @LastEditTime: 2022-06-09 10:25:53
-->
<template>
  <ExamineList :dataSource="3"></ExamineList>
</template>

<script>
import ExamineList from "./components/ExamineList";
export default {
  components: {
    ExamineList,
  },
  data() {
    return {};
  },
};
</script>

<style lang="scss" scoped></style>
